'use strict';
(() => {
  const cfg = window.SITE_CONFIG || {analyticsEnabled: false};
  const menu = document.querySelector('.menu');
  const nav = document.querySelector('#navlinks');
  menu?.addEventListener('click', () => {
    const expanded = menu.getAttribute('aria-expanded') !== 'true';
    menu.setAttribute('aria-expanded', String(expanded)); nav.classList.toggle('open', expanded);
  });
  document.addEventListener('keydown', e => { if(e.key === 'Escape' && menu?.getAttribute('aria-expanded') === 'true') { menu.setAttribute('aria-expanded','false'); nav.classList.remove('open'); menu.focus(); }});
  const consent = document.querySelector('#consent');
  const key = 'agency-analytics-consent-v1';
  let choice = null, loaded = false;
  try { choice = localStorage.getItem(key); } catch (_) {}
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  function loadAnalytics() {
    if (!cfg.analyticsEnabled || choice !== 'granted' || loaded) return;
    loaded = true;
    gtag('consent', 'default', {analytics_storage:'granted', ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied'});
    gtag('js', new Date());
    // Do not send user-entered query strings, fragments, or referrer parameters.
    const safeReferrer = (() => {try {const u=new URL(document.referrer);return u.origin+u.pathname;}catch(_){return '';}})();
    gtag('config',cfg.ga4Id,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false,page_location:location.origin+location.pathname,page_referrer:safeReferrer});
    gtag('event','page_view',{page_location:location.origin+location.pathname,page_referrer:safeReferrer,page_title:document.title,insurance_category:document.body.dataset.category});
    const script=document.createElement('script'); script.async=true; script.src='https://www.googletagmanager.com/gtag/js?id='+encodeURIComponent(cfg.ga4Id); document.head.appendChild(script);
  }
  loadAnalytics();
  if(cfg.analyticsEnabled && choice === null) consent.hidden = false;
  function removeAnalyticsCookies() {
    const host=location.hostname.split('.');
    document.cookie.split(';').map(x=>x.split('=')[0].trim()).filter(n=>/^_ga(?:_|$)|^_gid$|^_gat/.test(n)).forEach(n=>{
      document.cookie=n+'=; Max-Age=0; path=/; SameSite=Lax';
      for(let i=0;i<host.length-1;i++){ const domain=host.slice(i).join('.');document.cookie=n+'=; Max-Age=0; path=/; domain='+domain+'; SameSite=Lax';}
    });
  }
  function choose(value) {
    const withdraw=loaded && value!=='granted';choice=value;
    try{localStorage.setItem(key,value);}catch(_){}
    consent.hidden=true;
    document.querySelector('#privacy-status').textContent=value==='granted'?'Analytics allowed.':'Analytics declined.';
    if(withdraw){window['ga-disable-'+cfg.ga4Id]=true;removeAnalyticsCookies();location.reload();return;}
    loadAnalytics();
    if(!cfg.analyticsEnabled) document.querySelector('#privacy-status').textContent='Analytics is not enabled on this review website.';
  }
  document.querySelector('#accept-analytics')?.addEventListener('click',()=>choose('granted'));
  document.querySelector('#reject-analytics')?.addEventListener('click',()=>choose('denied'));
  document.querySelector('#privacy-settings')?.addEventListener('click',()=>{consent.hidden=false;document.querySelector('#reject-analytics').focus();});
  // Only actual conversion links generate click intent events. No interception of navigation.
  document.addEventListener('click', e => {
    const link=e.target.closest('a[data-event]');
    if(!link || !cfg.analyticsEnabled || choice!=='granted' || !loaded) return;
    const name=link.dataset.event;
    if(!['insurance_site_outbound','auto_quote_outbound'].includes(name)) return;
    gtag('event',name,{insurance_category:link.dataset.category || 'general',button_placement:link.dataset.placement || 'body',page_path:location.pathname,transport_type:'beacon'});
  });
})();
